// Format currency to BRL
export const formatCurrency = (value) => {
  const numValue = parseFloat(value) || 0;
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(numValue);
};

// Format currency with parentheses for negative values (accounting style)
export const formatAccountingCurrency = (value) => {
  const numValue = parseFloat(value) || 0;
  const formatted = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(Math.abs(numValue));
  
  return numValue < 0 ? `(${formatted})` : formatted;
};

// Format date
export const formatDate = (date) => {
  if (!date) return '';
  return new Intl.DateTimeFormat('pt-BR').format(new Date(date));
};

// Format CPF/CNPJ
export const formatCpfCnpj = (value) => {
  if (!value) return '';
  const cleaned = value.replace(/\D/g, '');
  
  if (cleaned.length <= 11) {
    // CPF: 000.000.000-00
    if (cleaned.length === 11) {
      return cleaned.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    } else if (cleaned.length > 6) {
      return cleaned.replace(/(\d{3})(\d{3})(\d{0,3})(\d{0,2})/, '$1.$2.$3-$4').replace(/-$/, '');
    } else if (cleaned.length > 3) {
      return cleaned.replace(/(\d{3})(\d{0,3})/, '$1.$2').replace(/\.$/, '');
    }
    return cleaned;
  } else {
    // CNPJ: 00.000.000/0000-00
    if (cleaned.length === 14) {
      return cleaned.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
    } else if (cleaned.length > 12) {
      return cleaned.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{0,2})/, '$1.$2.$3/$4-$5').replace(/-$/, '');
    } else if (cleaned.length > 8) {
      return cleaned.replace(/(\d{2})(\d{3})(\d{3})(\d{0,4})/, '$1.$2.$3/$4').replace(/\/$/, '');
    } else if (cleaned.length > 5) {
      return cleaned.replace(/(\d{2})(\d{3})(\d{0,3})/, '$1.$2.$3').replace(/\.$/, '');
    } else if (cleaned.length > 2) {
      return cleaned.replace(/(\d{2})(\d{0,3})/, '$1.$2').replace(/\.$/, '');
    }
    return cleaned;
  }
};

// Validate CPF
export const validateCPF = (cpf) => {
  const cleaned = cpf.replace(/\D/g, '');
  
  if (cleaned.length !== 11) return false;
  
  // Check for known invalid CPFs (all digits the same)
  if (/^(\d)\1{10}$/.test(cleaned)) return false;
  
  // Validate first check digit
  let sum = 0;
  for (let i = 0; i < 9; i++) {
    sum += parseInt(cleaned.charAt(i)) * (10 - i);
  }
  let checkDigit = 11 - (sum % 11);
  if (checkDigit === 10 || checkDigit === 11) checkDigit = 0;
  if (checkDigit !== parseInt(cleaned.charAt(9))) return false;
  
  // Validate second check digit
  sum = 0;
  for (let i = 0; i < 10; i++) {
    sum += parseInt(cleaned.charAt(i)) * (11 - i);
  }
  checkDigit = 11 - (sum % 11);
  if (checkDigit === 10 || checkDigit === 11) checkDigit = 0;
  if (checkDigit !== parseInt(cleaned.charAt(10))) return false;
  
  return true;
};

// Validate CNPJ
export const validateCNPJ = (cnpj) => {
  const cleaned = cnpj.replace(/\D/g, '');
  
  if (cleaned.length !== 14) return false;
  
  // Check for known invalid CNPJs (all digits the same)
  if (/^(\d)\1{13}$/.test(cleaned)) return false;
  
  // Validate first check digit
  let length = cleaned.length - 2;
  let numbers = cleaned.substring(0, length);
  const digits = cleaned.substring(length);
  let sum = 0;
  let pos = length - 7;
  
  for (let i = length; i >= 1; i--) {
    sum += parseInt(numbers.charAt(length - i)) * pos--;
    if (pos < 2) pos = 9;
  }
  
  let result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
  if (result !== parseInt(digits.charAt(0))) return false;
  
  // Validate second check digit
  length = length + 1;
  numbers = cleaned.substring(0, length);
  sum = 0;
  pos = length - 7;
  
  for (let i = length; i >= 1; i--) {
    sum += parseInt(numbers.charAt(length - i)) * pos--;
    if (pos < 2) pos = 9;
  }
  
  result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
  if (result !== parseInt(digits.charAt(1))) return false;
  
  return true;
};

// Validate CPF or CNPJ
export const validateCpfCnpj = (value) => {
  if (!value) return false;
  const cleaned = value.replace(/\D/g, '');
  
  if (cleaned.length === 11) {
    return validateCPF(cleaned);
  } else if (cleaned.length === 14) {
    return validateCNPJ(cleaned);
  }
  
  return false;
};

// Parse currency input
export const parseCurrency = (value) => {
  if (!value) return 0;
  const cleaned = value.toString().replace(/[^\d,.-]/g, '').replace(',', '.');
  return parseFloat(cleaned) || 0;
};

// Get status label
export const getStatusLabel = (status) => {
  const labels = {
    pending: 'Pendente Aprovação',
    approved: 'Aprovado',
    rejected: 'Reprovado',
    paid: 'Pago'
  };
  return labels[status] || status;
};

// Get status class
export const getStatusClass = (status) => {
  const classes = {
    pending: 'status-pending',
    approved: 'status-approved',
    rejected: 'status-rejected',
    paid: 'status-paid'
  };
  return classes[status] || '';
};
